import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDresser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDresser"><Path d="M3.5 3.5H20.5V18.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M20 11L4 11" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 18.75V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 18.75V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 6.5H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 13.5H13.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDresser;
